import * as Yup from 'yup'

const NewVisitLocationSchema = Yup.object().shape({
  isOutsideUS: Yup.boolean().required('Location is required to schedule a visit.'),
})

export default NewVisitLocationSchema
